import Service, { getCallApiFunction } from '../service'

type ParamsType = {
  roomId: string | null
}

class FetchRoomCanAccessApi extends Service {
  constructor({ roomId }: ParamsType) {
    super()
    this.config = {
      url: '/v1/room/can-access',
      method: 'GET',
      params: {
        roomId,
      },
    }
    this.name = 'FetchRoomCanAccessApi'
  }
}

export const fetchRoomCanAccess = async (params: ParamsType) => getCallApiFunction(new FetchRoomCanAccessApi(params))
